// components/TurnosPorDia.jsx
import React, { useMemo } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

/*
 Props:
   - turnos: array de turnos { fecha, ... }
   - range: "day" | "week" | "month" (we'll support day/week/month - aggregated)
   - type: "bar" | "line"
*/
export default function TurnosPorDia({ turnos = [], range = "day", type = "bar", limit = 30 }) {
  const data = useMemo(() => {
    const map = {};
    const toKey = (d) => {
      const date = new Date(d);
      if (range === "week") {
        const yyyy = date.getFullYear();
        const onejan = new Date(yyyy, 0, 1);
        const week = Math.ceil((((date - onejan) / 86400000) + onejan.getDay() + 1) / 7);
        return `${yyyy}-W${week}`;
      }
      if (range === "month") {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
      }
      // default day
      return new Date(date).toDateString();
    };

    turnos.forEach((t) => {
      const k = toKey(t.fecha);
      map[k] = (map[k] || 0) + 1;
    });

    const arr = Object.entries(map)
      .map(([k, v]) => ({ label: k, value: v }))
      .sort((a, b) => new Date(a.label) - new Date(b.label))
      .slice(-limit);

    return arr;
  }, [turnos, range, limit]);

  if (!data || data.length === 0) return <div className="chart-empty">Sin datos para graficar</div>;

  return (
    <div className="chart-container">
      <ResponsiveContainer width="100%" height={260}>
        {type === "bar" ? (
          <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" tick={{ fontSize: 12 }} />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="value" fill="#b08b76" />
          </BarChart>
        ) : (
          <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" tick={{ fontSize: 12 }} />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line type="monotone" dataKey="value" stroke="#b08b76" strokeWidth={2} />
          </LineChart>
        )}
      </ResponsiveContainer>
    </div>
  );
}
